import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ISiteRequestDetails } from 'src/app/feature/site-rediness-matrix/models/request';

export const SiteRequestApprovalsAdapter = createEntityAdapter<ISiteRequestDetails>({ selectId: (item: ISiteRequestDetails) => item.id });
export interface SiteRequestApprovalsState extends EntityState<ISiteRequestDetails> {
  isLoaded?: boolean;
  message?: string | null;
  selectedItemId?: number;
}
export const intialSiteRequestApprovalsState: SiteRequestApprovalsState = SiteRequestApprovalsAdapter.getInitialState({
  isLoaded: false,
});

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = SiteRequestApprovalsAdapter.getSelectors();

export const selectSiteRequestApprovalsEntities = selectEntities;

export const selectAllSiteRequestApprovalsEntities = selectAll;

export const getSiteApprovalsIsLoaded = (state: SiteRequestApprovalsState) => state.isLoaded;
export const getSiteApprovalsMessage = (state: SiteRequestApprovalsState) => state.message;
export const getSiteApprovalsSelectedId = (state: SiteRequestApprovalsState) => state.selectedItemId;


